import React from 'react';
import { useFeatureFlags } from 'components/shared/hooks';
import Section, { SectionHeader } from 'components/PathBuilder/Sidebar/Section';
import Text, { TEXT_VARIANTS } from 'components/ui/Typography/Text';

const ConfirmationEmails = ({ isMandatory }) => {
  const hasEventsMandatory = useFeatureFlags(['learning_events_mandatory']);
  return (
    <Section>
      <SectionHeader className="d-f jc-sb">
        <span>
          {hasEventsMandatory
            ? t('in_person_training.event_overview.invitation.title')
            : t('in_person_training.event_overview.confirmation_emails.title')}
        </span>
      </SectionHeader>
      {hasEventsMandatory ? (
        <Text variant={TEXT_VARIANTS.BODY_LIGHT} className="mb-4">
          {isMandatory
            ? t(
                'in_person_training.event_overview.invitation.description_mandatory',
              )
            : t(
                'in_person_training.event_overview.invitation.description_optional',
              )}
        </Text>
      ) : (
        <Text variant={TEXT_VARIANTS.BODY_LIGHT} className="mb-4">
          {t(
            'in_person_training.event_overview.confirmation_emails.description',
          )}
        </Text>
      )}
    </Section>
  );
};

export default ConfirmationEmails;
